export const NGS_SINGPASS_URL = "https://app.givepls.com/"; // NGS singpass url for QR code generation 
export const NGS_SINGPASS_ENV = 'UAT' // DEV, UAT, PROD
export const BASE_URL= "https://kv0hdmvonc.execute-api.ap-southeast-1.amazonaws.com/Stage/api/eDonation"
export const BASE_URL_ENROLL= "https://at1kmbnik3.execute-api.ap-southeast-1.amazonaws.com/Stage";
export const BASE_URL_OXPAY = "https://lle848p3k8.execute-api.ap-southeast-1.amazonaws.com/Stage";
export const BASE_URL_MUISAPI = "https://uat-muisapi.givepls.com/payment-v8";
export const RECEIPT_URL = "https://lle848p3k8.execute-api.ap-southeast-1.amazonaws.com/Stage";
export const SINGPASS_PLATFORM = 'web';
export const SINGPASS_SEPERATOR = '_';
export const SINGPASS_APPS = {
    MYINFO : 'myinfo',
    SGVERIFY : 'sgverify'
}
//--------------------AUTH0 DETAILS ----------------------
export const REACT_APP_AUTH0_DOMAIN = "ngs-development.au.auth0.com";
export const REACT_APP_AUTH0_CLIENT_ID = "POfErXPM6V4LXXUxQCXnXheZ6oUbhHQa";
export const CONNECTION_TYPE = "Username-Password-Authentication";

//-------------------- STRIPE DETAILS --------------------
export const STRIPE_KEY = "pk_test_0i0Up5UNkTgfCwiQPOkM6LoD001AjQYhUq";
export const STRIPE_SECRCT = "test";

// -------------------- NGS DETAILS ----------------------- 
export const ENROLL_MANULLY_ID = 1;
export const ENROLL_CORPORATE_ID = 2;
export const NGS_CHARITY_ID = 15;
export const MUIS_CHARITY_ID = 24;
export const DONATION_AMOUNT = 1000000000000000; 
export const CLIENT_PARAM = 'ourmasjid';
export const OUR_MASJID_APP_ID = 2;
export const GPAY_3DSGD = '82a241a3fc6385b';
export const GPAY_NO3DSGD = 'babe3c969688efc';
export const GPAY_RECSGD = 'bba2334d23fb4f5';
export const PAYMENT_METHOD = 'WorldPay';

export const DEFAULT_API_ERROR = `Our server is down, we'll back to normal soon`

export const CARD_TYPES = {
    VISA : 'VISA',
    MASTERCARD : 'Mastercard',
    AMEX : 'Amex',
    AMERICANEXPRESS : 'AMERICANEXPRESS',
    ECMC : 'ECMC'
}

export const PAYMENT_PARTNER = {
    WORLDPAY : 'WorldPay',
}

export const RESPONSE_CODES = {
    SUCCESS : 1,
    FAILURE : 0
}

export const OXPAY_RESPONSE = {
    FAILED : 'failed',
    SUCCESS : 'succeeded',
    PENDING : 'pending',
    INITIATED : 'initiated',
}

export const REGEX = {
    TITLECASE : /\b(\w)/g
}

export const MODAL_MESSAGE = {
    ERROR : 'Oops! Something went wrong'
}

export const DEFAULT_ORDER = 1
export const DEFAULT_CARD_NAME = 'Card Holder Name'
export const WORLD_PAY_BASE_URL = "https://l81c6bg7gf.execute-api.ap-southeast-1.amazonaws.com/Stage/api/eDonation"
export const WORLDPAY_PUBLIC_KEY = '1#10001#be68bfb3aca26ef4f99df83edf415261131adbbb3a'
+ 'bfd056f5dac7bc9a30e5243734f4e614ccea04e72193bed5e8'
+ '219c06b16f902644e0d554220e07eb66da3b1f33b355daeef2'
+ '059bc9f9ad5dca3035846c872f8ca3c5df8f9b8dc466bfacde'
+ '0c047ca1ab66f498c71b24c54b2ce5e844c052bf1cffc21574'
+ 'a3efc3f33a5188f2df75d7f7f0318d0e1e5d6881220fe4acbb'
+ '0a5e29886e1fa47410a2186dd6ce9a34b796dddf06afb15800'
+ '446a967fd4d817def1c46ccde89684ae7cf71547daa5ff3df9'
+ '90edcc91c49ca9e25003753ce0494bff67b6704857cec658e1'
+ '2a3b3d6ad18f3443d4d5cd21a28e8123084c32d6a6f9ca6c2b'
+ 'da6fac58d7e67f0b8939'

//----------------- HOMEPAGE BLOCK IDS ------------------- 
export const NEWS_LETTER_BLOCK_ID = 13;
export const GALLARY_EXPLORE_BLOCK_ID = 14;
export const CONTACT_US_BLOCK_ID = 15;
export const SOCIAL_MEDIA_BLOCK_ID = 16;
export const DONATION_BLOCK_ID = 5;
export const ADOPT_ART_WORK_BLOCK_ID = 6;
export const CORE_PRIVILEDGE_BLOCK_ID = 9;
export const PATRON_HEADING_BLOCK_ID = 8;
export const PATRON_PROGRAM_BLOCK_ID = 10;
export const DONOR_WALL_BLOCK_ID = 12;
export const ACHIEVEMENTS_BLOCK_ID = 7;
export const DONATION_WIDGET__BLOCK_ID = 4;

//--------------------------------------------------
export const DONOR_WALL_DONOTE_NOW_SETTING_ID = 16;
export const DONOR_WALL_SEE_WALL_SETTING_ID = 15;
export const DATE_FORMAT_DAYS = 'DD MMM';
export const DATE_FORMAT_YEARS = 'DD MMM YYYY'

//------------------------------------------------------
export const DONATION_MIN_AMOUNT = 5;
export const DONATION_MAX_AMOUNT = 999999;

export const CONTACT_US = "";
export const SUPPORT = "";
export const SITE_MAP = "";
export const TERMS_OF_USE = "https://www.muis.gov.sg/Footer/Terms-of-Use";
export const PRIVACY_POLICY = "https://www.muis.gov.sg/Footer/Privacy-Statement";
export const TERMS_CONDITION = "";

//------------------------------------------------------

export const PATRON_MIN_AMOUNT = 2000;
export const PATRON_MAX_AMOUNT = 999999;

export const ADOPT_MIN_AMOUNT = 50;
export const ADOPT_MAX_AMOUNT = 200000;
export const DATE_FORMAT = 'D MMM YYYY'; // 04 Jan 2019
export const HOUR_MINS = 'h:mm A';  // Hour and minute with AM/PM

export const PAYMENT_TYPES = {
    CARD_PAYMENT: 1,
    GOOGLE_PAY: 2,
    APPLE_PAY: 3
    
}

export const PAYMENT_ORDER = 1;
export const PAYMENT_METHODS = {
    GRAB_PAY : 'grabpay'
}

export const PaymentStatus = { SUCCESS: 0, FAILURE: 1, CANCEL: 2 };



export const uat = {
    BASE_URL_DOMAIN: "https://uat-muisapi.givepls.com", // Common domain for all configuration, donor and payment APIs 
    // BASE_URL_ENROLL: "https://at1kmbnik3.execute-api.ap-southeast-1.amazonaws.com/Stage", // Enroll end point
    // BASE_URL_CONFIG: "https://2r8ub4ylph.execute-api.ap-southeast-1.amazonaws.com/Stage",
    // BASE_URL_OXPAY: "https://lle848p3k8.execute-api.ap-southeast-1.amazonaws.com/Stage",
    // RECEIPT_URL : "https://lle848p3k8.execute-api.ap-southeast-1.amazonaws.com/Stage",
    // COGNITO_URL: "https://at1kmbnik3.execute-api.ap-southeast-1.amazonaws.com/Stage", 
    NGS_SINGPASS_URL: "https://staging.givepls.com",
    PAYNOW_QR_URL : "https://test-payment.givepls.com", // paynow url for QR code generation
    BASE_URL_POSTALCODE : "https://uat-muiscrmapi.givepls.com", //postal code api base url
    NGS_SINGPASS_ENV: 'UAT',
    CLIENT_PARAM: 'muis',
    SINGPASS_PLATFORM: 'web',
    SINGPASS_SEPERATOR: '_',
    SINGPASS_APPS: {
       MYINFO: 'myinfo',
       SGVERIFY: 'sgverify'
    },
 
    INSURANCE_TYPE: {
       CONVENTIONAL: 1,
       TAKAFUL: 2
    },
 
    OXPAY_RESPONSE : {
       FAILED : 'failed',
       SUCCESS : 'succeeded',
       PENDING : 'pending',
       INITIATED : 'initiated',
    },
 
    // SECRET_KEY: "MUIS_SECRET_KEY",
    SESSION_TIME: {
       NEW: 60,
       EXTENDED: 100
    },
    SAFARI_FORMAT: {
       DATE: 'D MMM YYYY',
       TIME: 'h:mm A'
    },
 
    RECALL_DELAY: 30000,
    WORLDPAY_3DS_AMOUNT: 10000,
 
    PAYMENT_METHOD: {
       PAYNOW: 'PayNow',
       DEBITCARD: 'DebitCard'
    },
 
    COUNTRY_CODE: {
       SINGAPORE : 'SG'
    },
 
    RATES: {
       RATE_ON_TOTAL: 0.025
    },
 
    REGEX : {
       TITLECASE : /\b(\w)/g,
       NRIC: /^[STFGM]\d{7}[A-Z]$/,
       UEN: /^[A-Za-z0-9]*$/,
       UEN1: /((S|T|[0-9])([a-zA-Z0-9]{8,9})|([0-3])(\d{8})([A-Z]))/g,
       COMPANY_NAME: /^[a-zA-Z0-9\-&.\s]*$/,
       CONTACT_PERSON: /^[a-zA-Z\s]*$/,
       EMAIL_ADDRESS: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
       PASSWORD:/^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{7,}$/,
    },
 
    FLOW : {
       MANUALLY : 'Manually',
       SINGPASS : 'Singpass',
       ANONYMOUS : 'Anonymous'
    },
 
    DATE_FORMAT : {
       NEXT_ZAKAT: 'DD MMM YYYY'
    },
 
    CARD_TYPES: {
       VISA: 'VISA',
       MASTERCARD: 'Mastercard',
       AMEX: 'Amex',
       AMERICANEXPRESS: 'AMERICANEXPRESS',
       ECMC: 'ECMC'
    },
 
    DEFAULT_ORDER: 1,
    DONATION_AMOUNT: 1000000000000000,
    DEFAULT_CARD_NAME: 'Card Holder Name',
    
    PAYMENT_TYPES: {
       CARD_PAYMENT: 1,
       GOOGLE_PAY: 2,
       APPLE_PAY: 3
    },
    
    LOGIN_DETAILS: {
       GOOGLE_CLIENT_ID: "431838566550-su7u1tfn7s35t4pib702pme7od3e5cbl.apps.googleusercontent.com",
       FACEBOOK_APP_ID: "1037397753647355"
    },
    
    PAYMENT_STATUS: {
      ACCEPTED: 'Accepted',
      COMPLETED: 'Completed',
      REFUNDED: 'Refunded',
      VOIDED: 'Voided',
      AMOUNT_ACCEPTED: 'amt accepted',
      AMOUNT_COMPLETED: 'amt accepted',
      AMOUNT_REFUNDED: 'amt refunded',
      AMOUNT_VOIDED: 'amt refunded',
   },
 
    //--------------------AUTH0 DETAILS ----------------------
    CONNECTION_TYPE: "Username-Password-Authentication",
 
    // -------------------- MUIS DETAILS ----------------------- 
    ENROLL_MANULLY_ID: 1,
    ENROLL_CORPORATE_ID: 2,
    MUIS_CHARITY_ID: 24,
    APPEAL_ID_DEFAULT: 0,
 
    //----------------- HOMEPAGE BLOCK IDS ------------------- 
    NEWS_LETTER_BLOCK_ID: 13,
    GALLARY_EXPLORE_BLOCK_ID: 14,
    CONTACT_US_BLOCK_ID: 15,
    SOCIAL_MEDIA_BLOCK_ID: 16,
    DONATION_BLOCK_ID: 5,
    ADOPT_ART_WORK_BLOCK_ID: 6,
    CORE_PRIVILEDGE_BLOCK_ID: 9,
    PATRON_HEADING_BLOCK_ID: 8,
    PATRON_PROGRAM_BLOCK_ID: 10,
    DONOR_WALL_BLOCK_ID: 12,
    ACHIEVEMENTS_BLOCK_ID: 7,
    DONATION_WIDGET__BLOCK_ID: 4,
 
    //--------------------------------------------------
    DONOR_WALL_DONOTE_NOW_SETTING_ID: 16,
    DONOR_WALL_SEE_WALL_SETTING_ID: 15,
 
    //------------------------------------------------------
    DONATION_MIN_AMOUNT: 0.01,
    DONATION_MAX_AMOUNT: 999999,
 
    CONTACT_US: "#",
    SUPPORT: "#",
    SITE_MAP: "#",
    TERMS_OF_USE: "https://www.muis.gov.sg/Footer/Terms-of-Use",
    PRIVACY_POLICY: "https://www.muis.gov.sg/Footer/Privacy-Statement",
    TERMS_CONDITION: "#",
 
    //------------------------------------------------------
    TYPE: "UAT",
 
    // PAYMENT DONE THANK YOU VIDEO YOUTUBE URL
    PAYMENT_THANK_YOU_VIDEO: 'https://www.youtube.com/embed/Ln4VZEDGgc4',
 
    // GOOGLE POSTAL CODE SERVICE
    GOOGLE_POSTAL_CODE_BASE_URL:'https://maps.googleapis.com/maps', //URL to get postal code
 
    //PAYNOW TIMER CONSTANTS IN MILLISECONDS
    QR_EXPIRE_DURATION : 3 * 60 * 1000, // 3 mins
    CHK_STATUS_INTERVAL : 3000, //3 sec
    ENQUIRY_GRACE_PERIOD : 30 * 1000, // 30 sec
 
    //ZAKAT BUSINESS CALCULATOR - MAXIMUM AMOUNT LIMIT ON FIELD
    MAX_AMT_LENGTH : 14 // $9,999,999,999
 }
 export const config = uat;

 export const TIME_ZONE = {
   SINGAPORE : "SGT",
   GREENWICH : "GMT",
}

export const paths = {
    WorldPayCSE: '/common/wp/WPCSE',
    GPay3DSGD: '/common/wp/GPKEY',
    GPayNo3DSDG: '/common/wp/GP_NO3D_KEY',
    GPayRec3DSDG: '/common/wp/GP_REC_KEY',
    StripeSecret: '/common/STRIPE_PK',
    SessionKey: '/muis/SECRET_KEY',
    ReceiptKey: '/muis/RCPTKEY',
    CognitoLoginAccessKey: '/muis/COGNITO_LOGIN_ACCESS_KEY',
    CognitoLoginClientId: '/muis/COGNITO_LOGIN_CLIENT_ID',
    AuthorizerAccessKey: '/common/AWS_USER_POOL_ID',
    AuthorizerClientId: '/common/AWS_CLIENT_ID'
 }

export const DATE_FORMAT_REGEX = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/
export const REACT_APP_CRYPTO_JS_PASSWORD = 'ApSt28622';
export const REDUX_ENCRYPTION_KEY = "€Koj;yu(Rok5)S&";
export const CRYPTO_ACCESS_KEY = "ptjXV9hR%EC&a!QK";
export const AWS_SECRET_ACCESS_KEY = "U2FsdGVkX18xKIXwaq1D/2mL2hw0S46hti6bclhWlSMjwQkhm+vr9V8oCrPLiO8Al3UF4S9EebZ0bh4pnk09dA==";
export const AWS_SECRET_KEY_ID = "U2FsdGVkX1/q+JnASo9ii+A3J3KZdjBsK8jCUgE+5Gal/Suzx3JWaXVCn4JdF3XC";
export const AWS_REGION = "ap-southeast-1"